var initFocusInput = function() {
    jQuery('.control').on('click', function() {
        var $this = jQuery(this);
        $this.find('input').focus();
        $this.closest('form').find('.control').removeClass('is-active');
        $this.addClass('is-active');
    });
    jQuery('input').blur(function() {
        var $this = jQuery(this);
        $this.closest('.control').removeClass('is-active');
    });
}

export {
    initFocusInput
};